export enum PortfolioErrorType {
  CREATE_NAME_CONFLICT = 'CREATE_NAME_CONFLICT',
  MOVE_UPLOADED_ITEMS_TO_PORTFOLIO = 'MOVE_UPLOADED_ITEMS_TO_PORTFOLIO',
  UNKNOWN = 'UNKNOWN',
}

export const portfolioErrorMessages = {
  [PortfolioErrorType.CREATE_NAME_CONFLICT]: 'Portfolio with this name already exists',
  [PortfolioErrorType.MOVE_UPLOADED_ITEMS_TO_PORTFOLIO]:
    'Failed to move uploaded items to the destination portfolio',
  [PortfolioErrorType.UNKNOWN]: 'Failed to create or edit portfolio',
};
